export const NotificationType = {
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
};
